import { combineEpics, createEpicMiddleware } from "redux-observable";
import loginEpics from "./login-epics";
import userEpics from "./user-epics";

export const rootEpic = combineEpics(loginEpics, userEpics);

export default createEpicMiddleware();
